import { ShieldAlert } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { GetQualityIssuesNodeData } from '@repo/shared-types';

export const GetQualityIssuesNode = ({
  data,
  selected,
}: {
  data: GetQualityIssuesNodeData;
  selected?: boolean;
}) => {
  const subtitle = [
    data.minSeverity ? `≥ ${data.minSeverity}` : null,
    data.outputKey ? `→ ${data.outputKey}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <NodeShell
      type="get_quality_issues"
      icon={<ShieldAlert size={16} />}
      label={data.label}
      subtitle={subtitle || undefined}
      selected={selected}
    />
  );
};
